'use client'
import { FC } from 'react'
import { Contact, IContactProps } from 'storefront-modules/contact'
import { useModal } from '#/src/custom/controllers'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { RequestSentOverrides } from 'storefront-modules/types'
import { overrideText } from 'ui/lib/overrides'

export interface CustomContactProps extends Omit<IContactProps, 'apiPath' | 'sectionId'> {}

const CustomContact: FC<CustomContactProps> = ({ ...props }) => {
  const overrides = useOverridesContext<keyof RequestSentOverrides>()
  const { openModal } = useModal()

  const onSuccess = () => {
    openModal({
      title: overrideText('Begäran har skickats', overrides?.requestSent),
      componentId: 'confirmation',
      size: 'md'
    })
  }

  return (
    <Contact
      apiPath="/api/contact/send-contact"
      sectionId="contact"
      {...{ onSuccess }}
      {...props}
    />
  )
}

export default CustomContact
